var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24377 1.09488C5.31846 1.18559 5.36422 1.29659 5.37514 1.41355C5.38605 1.53051 5.36161 1.64806 5.30498 1.751C4.86257 2.56272 4.63153 3.47258 4.63311 4.39688C4.63311 7.47176 7.14155 9.96165 10.2331 9.96165C10.6364 9.96165 11.029 9.91959 11.4062 9.83929C11.5219 9.81427 11.6423 9.82384 11.7526 9.86682C11.8628 9.90979 11.9579 9.98427 12.0261 10.0809C12.098 10.1815 12.1347 10.3029 12.1304 10.4264C12.1261 10.5499 12.0811 10.6685 12.0023 10.7638C11.4021 11.5006 10.645 12.0942 9.78608 12.5014C8.92717 12.9086 7.98815 13.1191 7.03748 13.1176C3.50974 13.1176 0.652344 10.2775 0.652344 6.77818C0.652344 4.14453 2.27005 1.88559 4.57342 0.928176C4.68816 0.879718 4.81553 0.869773 4.93641 0.899833C5.05728 0.929893 5.16514 0.998337 5.24377 1.09488V1.09488Z",
    fill: "#003777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMoon);
export default __webpack_public_path__ + "static/media/menu_moon.9a2b3ada941a8b0263d4e6a9067a9532.svg";
export { ForwardRef as ReactComponent };